/**
 * 全ページ共通 Utilityファイル
 */
let gv_cons = nsOiOi.cons;
let gv_util = nsOiOi.util;
let gv_lang	= nsOiOi.language;

(()=> {

	/**
	 * TTS記事データ取得時、現在のドメインを参照し、
	 * リリースドメインの場合は相対パスを指定
	 * 異なる場合は絶対リンクへ変換
	 * @param  {String} aPath	- 対象ファイルのパス
	 * @return {String}			- 書き換え済みURL
	 */
	gv_util.getTtsDataCheckDomain = (aPath)=> {
		const currentDomain = location.hostname;
		let result;
		_.some(gv_cons.RELEASE_DOMAIN, (aDomain) => {
			if(aDomain === currentDomain) {
				result = aPath;
				return true;
			}
		})

		if(!result && gv_cons.RELEASE_DOMAIN_REGEXP.test(currentDomain)) {
			result = aPath;
		}

		if(!result) {
			result = `${gv_cons.DEBUG_DIR_PATH}${gv_cons.MARUI_DOMAIN}${aPath}`;
		}
		return result;
	};

		/**
	 * 引数がオブジェクトの場合、配列を生成して引数オブジェクトを
	 * 配列に挿入
	 * @param  {Object || Array} aTestData	- 判定データ
	 * @return {Array}						- 変換済みデータ
	 */
		 gv_util.convObjInArray = (aTestData)=> {
			let wrapAry	= [];
			if(aTestData instanceof Array) {
				return aTestData;
			} else {
				wrapAry.push(aTestData);
				return wrapAry;
			}
		};

	/**
	 * 現在のドメインが本番か判定し結果を出力
	 * @return {Boolean} result - 本番ドメインの場合はtrue
	 */
	gv_util.checkReleaseDomain = ()=> {
		const nowDomain	= location.hostname;
		let result		= false;
		_.some(gv_cons.RELEASE_DOMAIN, (aDomain) => {
			if(nowDomain === aDomain) {
				result = true;
				return true;
			}
		});
		return result;
	};

	/**
	 * 引数のドメインが本番か判定し結果を出力
	 * @param  {String}  aUrl- 検査対象URL文字列
	 * @return {Boolean} result - 本番ドメインの場合はtrue
	 */
	gv_util.checkReleaseDomainURL = (aUrl)=> {
		let extractUrl	= aUrl.replace(/https?:\/\/(.*?)\/.*/, '$1');
		let result		= false;

		_.some(gv_cons.RELEASE_DOMAIN, (aDomain) => {
			if(extractUrl === aDomain) {
				result = true;
				return true;
			}
		});
		return result;
	};


	/**
	 * 翻訳言語文字列をもとにリンク先ドメイン文字列を返却
	 * @param  {String}		aLang	- 翻訳言語文字列
	 * @return {String}		result	- 対象ドメイン文字列
	 */
	gv_util.getLangDomain = (aLang)=> {
		let currentProtcol	= location.protocol;
		let currentDomain	= location.hostname;
		let isReleaseDomain = gv_util.checkReleaseDomainURL(currentDomain);
		let isDebug         = /^(localhost|192\.168\.*)$/.test(currentDomain);
		let makeUrl;
		let result;

		if(isReleaseDomain) {
			result	= gv_cons.TRANSER_CREATE_DOMAIN_MASTER.production[aLang];
		} else if(isDebug) {
			result = 'http://' + currentDomain;
		} else {
			makeUrl	= 'http://' + currentDomain;
			result	= makeUrl + gv_cons.TRANSER_CREATE_DOMAIN_MASTER.dev[aLang];
		}

		return result;
	};

	/**
	 * UserAgentから閲覧端末情報を取得
	 * @return  {String}	- PC => 'pc' SP => 'sp'
	 */
	gv_util.getDeviceUa = ()=> {
		const ua = navigator.userAgent.toLowerCase();
		const condRegAry = [
			/iphone/,
			/android/
		];
		let spFlag = false;
		_.some(condRegAry, (aReg) => {
			if(aReg.test(ua)) {
				spFlag = true;
				return true;
			}
		});
		if(spFlag) {
			return 'sp';
		} else {
			return 'pc';
		}
	};

	gv_util.getDeviceOs = () => {
		const ua		= navigator.userAgent.toLowerCase();
		const iOsUa		= /iphone/;
		const androidUa = /android/;

		if(iOsUa.test(ua)) {
			return 'iOS';
		} else if(androidUa.test(ua)) {
			return 'Android';
		}
	};

	/**
	 * 有効なMediaQueryを監視し対象端末文字列を返却
	 * @return  {String}	- PC => 'pc' SP => 'sp'
	 */
	gv_util.getMQDevice = ()=> {
		let pcCond = window.matchMedia('screen and (min-width:768px)');
		let spCond = window.matchMedia('screen and (max-width:767px)');

		if(pcCond.matches) {
			return 'pc';
		} else {
			return 'sp';
		}
	};

	/**
	 * ブラウザの設定言語を取得し返却
	 * @return {String} aBrowserLang - ブラウザ設定言語文字列
	 */
	gv_util.getBrowserSetLang = ()=> {
		return (window.navigator.languages && window.navigator.languages[0]) ||
            window.navigator.language ||
            window.navigator.userLanguage ||
            window.navigator.browserLanguage;
	};

	/**
	 * Windowリサイズイベント用
	 * @param  {Function} aFunc - リサイズ後実行関数
	 */
	gv_util.moveScreenWidth = (aFunc)=> {
		let spMediaQuery	= window.matchMedia('screen and (max-width:767px)');

		function checkBreakPoint(spMediaQuery) {
			if(spMediaQuery.matches) {
				let timer = false;
				let windowWidth	= $(window).width();
				$(window).on('resize', ()=> {
					let resizedWindowWidth = $(window).width();
					if(timer !== false) {
						clearTimeout(timer);
					}
					timer = setTimeout(()=> {
						if(windowWidth !== resizedWindowWidth) {
							aFunc();
						}
					}, 200)
				});
			} else {
				aFunc();
			}
		}

		spMediaQuery.addListener(checkBreakPoint);


		// $(window).on('orientationchange', (ev)=> {
		// 	aFunc();
		// });
	};

	gv_util.toggleScreenWidth = (aFunc) => {
		let timer = false;
		$(window).on('load resize', ()=> {
			if(timer !== false) {
				clearTimeout(timer);
			}
			timer = setTimeout(()=> {
				aFunc();
			}, 200)
		});
	};

	/**
	 * リンクURLが外部リンクか判定し返却
	 * @param  {String} aLinkUrl	- リンクURL文字列
	 * @return {Boolean}			- 判定結果
	 */
	gv_util.checkLinkUrlOuter = (aLinkUrl)=> {
		let replaceUrl = aLinkUrl.replace(gv_cons.HTTP_URL_MARUI_REGEXP, '');
		return gv_cons.HTTP_URL_REGEXP.test(replaceUrl);
	};

	/**
	 * TTS 記事公開日と現在日を比較し有効な記事か判定
	 * @param  {String} aTtsDate	- TTSで設定された日時（yyyymmdd）
	 * @param  {String('start'|'end')} aCond - 開始日 or 終了日
	 * @return {Boolean}			- 有効記事の場合はTrue
	 */
	gv_util.checkTtsArticleDate	= (aTtsDate, aCond) => {
		const nowDate			= new Date();
		const yyyy				= nowDate.getFullYear();
		const mm				= nowDate.getMonth() + 1;
		const dd				= nowDate.getDate();
		const forCompareDate	= new Date(`${yyyy}/${mm}/${dd}`).getTime();
		let convTtsDate			= aTtsDate.replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3');
		const forCondDate		= new Date(convTtsDate).getTime();

		switch(aCond) {
			case 'start':
				if(forCondDate <= forCompareDate) {
					return true;
				} else {
					return false;
				}
			break;
			case 'end':
				if(forCondDate >= forCompareDate) {
					return true;
				} else {
					return false;
				}
			break;
			default:
				return false;
			break;
		}
	};

	/**
	 * TTSショップ紹介付属情報を取得
	 * @param  {String} aSeq		- 取得連番
	 * @param  {Array}	aAnclyList	- ショップ付属リスト
	 * @return {String}				- 取得文字列
	 */
	gv_util.getShopAnclyData = (aSeq, aAnclyList)=> {
		let result;
		_.some(aAnclyList, (aAncly)=> {
			if(aSeq === aAncly.facility_incdl_display_seq) {
				result = aAncly.shop_ancly_info;
				return true;
			}
		});
		return result;
	};

	/**
	 * 第1引数のショップデータが第2引数のカテゴリー名称とマッチするか判定
	 * @param  {Array} aShopIntroCategory	- ショップ紹介カテゴリー配列
	 * @param  {String} aCategoryName		- 対象のカテゴリー名称
	 * @return {Boolean}					- カテゴリがマッチする場合はtrue
	 */
	gv_util.checkShopIntroTargetCategory = (aShopIntroCategory, aCategoryName)=> {
		if(aShopIntroCategory.shop_category.shop_category_name === aCategoryName) {
			return true;
		} else {
			return false;
		}
	};

	/**
	 * TTSショップ紹介、お取り扱いアイテム・ブランド一覧を取得
	 * @param  {Array} aItemsList	- お取り扱いアイテム配列
	 * @param  {String} aTargetKey	- 取得する配列キー
	 * @return {Array} resultAry	- 結果配列
	 */
	gv_util.getShopIntroItemBrandList = (aItemList, aTargetKey)=> {
		let isUndefined	= _.isUndefined(aItemList);
		let resultAry	= [];
		if(isUndefined) {
			return false;
		} else {
			_.each(aItemList[`shop_hndl_${aTargetKey}`], (aItem)=> {
				let addData	= {};
				addData.name		= aItem[`${aTargetKey}_name`];
				addData.displaySeq	= Number(aItem.display_seq);
				resultAry.push(addData);
			});
			resultAry.sort((a, b)=> {
				if(a.displaySeq < b.displaySeq) return -1;
				if(a.displaySeq > b.displaySeq) return -1;
				return 0;
			});
			return resultAry;
		}
	};


	/**
	 * TTSショップ紹介　ショップ付属情報を取得
	 * @param  {Array} aShopAnclyList	- ショップ付属情報配列
	 * @param  {String}	aShopAnclyKey	- 取得付属情報連番
	 * @return {String||Boolean}		- 存在する場合は対象の文字列を返却、無い場合はfalse
	 */
	gv_util.getShopIntroShopAncly = (aShopAnclyList, aShopAnclyKey)=> {
		let shopAnclyAry;
		let result;

		if(_.isUndefined(aShopAnclyList)) {
			return false;
		}

		if(!_.isArray(aShopAnclyList.shop_ancly_info)) {
			shopAnclyAry = _.toArray(aShopAnclyList.shop_ancly_info);
		} else {
			shopAnclyAry = aShopAnclyList.shop_ancly_info;
		}

		_.some(shopAnclyAry, (aShopAncly)=> {
			if(aShopAncly.facility_incdl_display_seq === aShopAnclyKey) {
				result = aShopAncly.shop_ancly_info;
				return true;
			}
		});
		if(!result) {
			result = false;
		}

		return result;
	};

	/**
	* 開始日と更新日を比較して、記事公開日を返す
	* @param {Number} aStartDateNum - 開始日
	* @param {Number} aUpdateDateTimeNum - 更新日時
	* @return {Number} 記事公開日
	*/
	gv_util.getPublishDateNum = function(aStartDateNum, aUpdateDateTimeNum){
		var updateDateNum = aUpdateDateTimeNum.substring(0, 8);
		if (aStartDateNum >= updateDateNum) {
			return aStartDateNum;
		} else {
			return updateDateNum;
		}
	};

	/**
	 * 記事開始日と更新日を比較して新しい数値の日付を返却し変換
	 * @param  {Number} aUpdate			- 記事更新日
	 * @param  {Number} aStartDate		- 記事開始日
	 * @return {String} aResultDateStr 	- 結果日付文字列
	 */
	gv_util.compareUpdateArticle = (aUpdate, aStartDate)=> {
		let forCompareUpdate	= aUpdate.replace(/^(\d{8}).*/, '$1');
		let updateHHMMSS		= aUpdate.replace(/.*(\d{6})$/, '$1');
		if(Number(forCompareUpdate) > Number(aStartDate)) {
			return aUpdate;
		} else if(Number(forCompareUpdate) < Number(aStartDate)) {
			return aStartDate + updateHHMMSS;
		} else {
			return aUpdate;
		}
	};

	/**
	 * 記事更新日文字列をもとにページ表示用文字列へ変換
	 * @param  {String} aUpdate	- 記事更新日文字列(yyyymmddhhmmss)
	 * @return {String}			- ページ表示用文字列(yy.mm.dd)
	 */
	gv_util.convUpdateDisp = (aUpdate)=> {
		return aUpdate
				.replace(/^\d{2}(\d{2})(\d{2})(\d{2}).*/, '$1.$2.$3')
				.replace(/\.0/g,'.');
	};

	/**
	 * 日付文字列を和式に変換し曜日を追加 mm月dd日(w)
	 * @param  {String} aDate	- 対象日付文字列
	 * @return {String}			- 変換済み文字列
	 */
	gv_util.convJpDate = (aDate)=> {
		if(typeof aDate === 'undefined') return '';
		if(/^9999.*/.test(aDate)) return '';
		if(!aDate) return '';

		let yyyy		= aDate.replace(/^(\d{4}).*/, '$1');
		let mm			= aDate.replace(/^\d{4}(\d{2}).*/, '$1');
		let dd			= aDate.replace(/^\d{6}(\d{2}).*/, '$1');
		let weekAry		= ['日', '月', '火', '水', '木', '金', '土'];
		let convDate	= new Date(`${yyyy}/${mm}/${dd}`);
		let resultWeek	= weekAry[convDate.getDay()];
		let result;

		result			= `${mm}月${dd}日(${resultWeek})`.replace(/0(\d)/g, '$1');
		return result;
	};

	/**
	 * yyyymmdd形式をyy.mm.ddに変換し返却
	 * @param  {String} aDate - 対象日付文字列
	 * @return {String} convDate    - 変換済み文字列
	 */
	gv_util.convEnDate = (aDate)=> {
		if(typeof aDate === 'undefined') return '';
		if(/^9999.*/.test(aDate)) return '';
		if(!aDate) return '';

		let yy		= aDate.replace(/^\d{2}(\d{2}).*/, '$1');
		let mm			= aDate.replace(/^\d{4}(\d{2}).*/, '$1');
		let dd			= aDate.replace(/^\d{6}(\d{2}).*/, '$1');
		let result;

		result			= `${yy}.${mm}.${dd}`.replace(/\.0(\d)/g, '.$1');
		return result;
	};

	/**
	 * 価格情報から表示用価格文字列を返却
	 * @param  {String} aPriceClass	- 価格表記区分
	 * @param  {String}	aPrice1		- 価格1
	 * @param  {String} aPrice2		- 価格2
	 * @return {String || Boolean} resultPrice	- 表示価格文字列
	 */
	gv_util.getDisplayPrice = (aPriceClass, aPrice1, aPrice2)=> {
		let notSetPrice 	= !aPrice1 && !aPrice2;
		let addPriceHead	= '税込：';
		let addPriceFoot	= '円';
		let jointPrice		= '～';
		let addCommaPrice1, addCommaPrice2, result;
		if(notSetPrice) return false;
		console.log(aPriceClass, aPrice1, aPrice2);
		switch(aPriceClass) {
			case '01':
				addCommaPrice1	= addPriceHead + gv_util.getCommaPrice(aPrice1) + addPriceFoot;
				result			= addCommaPrice1;
			break;

			case '02':
				addCommaPrice1	= addPriceHead + gv_util.getCommaPrice(aPrice1) + addPriceFoot;
				result			= addCommaPrice1 + jointPrice;
			break;

			case '03':
				addCommaPrice1	= addPriceHead + gv_util.getCommaPrice(aPrice1) + addPriceFoot;
				addCommaPrice2	= addPriceHead + gv_util.getCommaPrice(aPrice2) + addPriceFoot;
				result			= addCommaPrice1 + jointPrice + addCommaPrice2;
			break;

			case '04':
				addCommaPrice2	= addPriceHead + gv_util.getCommaPrice(aPrice2) + addPriceFoot;
				result			= jointPrice + addCommaPrice2;
			break;
		}

		return result;
	};

	/**
	 * 金額にカンマを付与
	 * @param  {Number} aPrice	- 金額
	 * @return {String}			- カンマ付与価格文字列
	 */
	gv_util.getCommaPrice = (aPrice)=> {
		return String(aPrice).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	};

	/**
	 * ネット通販リンクURLが公式か判定
	 * @param  {String} aUrl	- 投稿URL
	 * @return {String}			- 公式URLではない場合は空白を返却
	 */
	gv_util.checkWcLinkUrl = (aUrl)=> {
		let result;
		_.some(gv_util.EC_SITE_URL_ARY, (aUrlRegExp)=> {
			if(aUrlRegExp.test(aUrl)) {
				result = aUrl;
				return true;
			}
		});
		return result;
	};

	/**
	 * お店からのお知らせ・ショップニュース
	 * リンク先URLの生成
	 * @param  {String} aStcd			- 店舗番号
	 * @param  {String}	aArticleSeq		- 記事連番
	 * @param  {String} aArticleClass	- 記事区分
	 * @param  {String} resultUrl		- 生成URL
	 */
	gv_util.createArticleLink = (aStcd, aArticleSeq, aArticleClass)=> {
		let resultUrl;
		let filePath	= gv_cons.ARTICLE_DIR_MASTER[aArticleClass];
		resultUrl = `/${aStcd}${filePath}?article_id=${aArticleSeq}`;

		return resultUrl;
	};

	/**
	 * 店舗ニュース「フェアイベント」記事
	 * リンク先URLの生成
	 * @param  {String} aStcd			- 店舗番号
	 * @param  {String}	aArticleSeq		- 記事連番
	 * @param  {String} resultUrl		- 生成URL
	 */
	gv_util.createArticleLinkV1 = (aStcd, aArticleSeq)=> {
		let resultUrl;
		let filePath	= '/event/detail.html';
		let fileParam   = '&article_type=sto';
		resultUrl = `/${aStcd}${filePath}?article_seq=${aArticleSeq}${fileParam}`;

		return resultUrl;
	};

	/**
	 * イベント　ソート用日付データ取得
	 * @param  {String} aStartDate	- 企画実施開始日
	 * @param  {Number} resultDate	- ソート日付
	 */
	gv_util.getEventSortDate = (aStartDate)=> {
		let isNotStartDate	= typeof aStartDate === 'undefined';
		let resultDateTime;
		if(isNotStartDate) {
			resultDateTime = gv_util.getTodayTimeNumber();
		} else {
			resultDateTime = gv_util.getSetTimeNumber(aStartDate);
		}

		return resultDateTime;
	};

	/**
	 * イベント 未来のイベントか判定
	 * @param  {String}	aStartDate	- 企画実施開始日
	 * @param  {String} aEndData	- 企画実施終了日
	 * @return {Boolean}			- 未来イベントの場合はtrue
	 */
	gv_util.checkFutureEvent = (aStartDate, aEndData)=> {
		let isNotStart		= typeof aStartDate === 'undefined';
		let isNotEnd		= typeof aEndData === 'undefined';
		let todayDateNum	= gv_util.getTodayTimeNumber();
		let convStartDate, convEndDate;

		if(isNotStart && isNotEnd) {
			return;
		} else if(isNotStart) {
			convStartDate	= gv_util.getTodayTimeNumber();
			convEndDate		= gv_util.getSetTimeNumber(aEndData);
		} else if(isNotEnd) {
			convStartDate	= gv_util.getSetTimeNumber(aStartDate);
			convEndDate		= gv_util.getSetTimeNumber(gv_cons.EVENT_MAX_END_DATE_STR);
		} else {
			convStartDate	= gv_util.getSetTimeNumber(aStartDate);
			convEndDate		= gv_util.getSetTimeNumber(aEndData);
		}

		if(todayDateNum < convStartDate) {
			return true;
		} else {
			return false;
		}

	};


	/**
	 * imgデータ参照時、リリースドメイン以外は
	 * 外部ファイル取得用のパスへ変換
	 * @param  {String} aImgPath	- 画像のパス
	 * @return {String}				- 変換済みのパス
	 */
	 gv_util.imgDataPath	= (aImgPath)=> {
		const currentDomain = location.hostname;
		let result;

		if(typeof aImgPath === 'undefined') {
			return;
		}
		_.some(gv_cons.RELEASE_DOMAIN, (aDomain) => {
			if(aDomain === currentDomain) {
				result = aImgPath;
				return true;
			}
		})
		if(!result) {
			result = `${gv_cons.MARUI_DOMAIN}${aImgPath}`;
		}
		return result;
	};

	/**
	 * 現在のURLから開いているページを判定
	 * @return  {String} result	- ページ識別子
	 */
	gv_util.getPageType = ()=> {
		let path = location.pathname;
		let result;
		_.some(gv_cons.DECISION_PAGE_TYPE, (aRegExpAry, aPageType)=> {
			let condFlag	= false;
			_.some(aRegExpAry, (aRegExp)=> {
				if(aRegExp.test(path)) {
					result		= aPageType;
					condFlag	= true;
					return true;
				}
			});
			return condFlag;
		});
		return result;
	};

	/**
	 * NEWS&TOPICS 記事公開日から14日以内か判定
	 * @param  {String} aStartDateStr - 記事公開日
	 */
	gv_util.getNewsTopicsNewFlag = (aStartDateStr) => {

		let todayTime	= gv_util.getTodayTimeNumber()
		let setYear		= Number(aStartDateStr.replace(/^(\d{4}).*/, '$1'));
		let setMonth	= Number(aStartDateStr
							.replace(/^\d{4}(\d{2})\d{2}/, '$1')
							.replace(/^0(\d)/, '$1'));
		let setDate		= Number(aStartDateStr.replace(/.*(\d{2})$/, '$1')
							.replace(/^0(\d)/, '$1'));
		let convDate	= new Date(`${setYear}/${setMonth}/${setDate}`);

		convDate.setDate(convDate.getDate() + gv_cons.NEWS_TOPICS_NEW_DATE);

		if(convDate.getTime() >= todayTime) {
			return true;
		} else {
			return false;
		}
	};

	/**
	 * NEWS&TOPICS 文字数制限を超えた文字列を置換
	 * @param  {String} aArticleTxt - TTS投稿文字列
	 * @return {String}				- 変換済み文字列
	 */
	gv_util.cutNewsTopicsText = (aArticleTxt)=> {
		let validArticleTxt;

		if(typeof aArticleTxt === 'undefined') { return false};
		validArticleTxt	= aArticleTxt.substring(0, gv_cons.NEWS_TOPICS_LIMIT_STR_IDX);

		if(aArticleTxt.length < gv_cons.NEWS_TOPICS_LIMIT_STR) {
			return aArticleTxt;
		}
		validArticleTxt += '...';
		return validArticleTxt;
	};

	/**
	 * アコーディオンレイアウト共通設定
	 * @param  {jQuerySelector} aPanel		- 開閉のキーとなるエレメント
	 * @param  {jQuerySelector} aList		- 開閉対象エレメント
	 * @param  {String} aAddClass			- 開いている際に付与するクラス名
	 * @param  {Number|String} aDuration	- 開閉速度
	 * @param  {Number|String} aEasing		- 開閉アクションのイージング
	 */
	gv_util.accordionLayout = ($aPanel, $aList, aAddClass, aDuration = 300, aEasing = 'easeInOutQuart')=> {
		$aPanel.off('click');
		$aPanel.on('click', (elm)=> {
			if($aList.css('display') === 'none') {
				$aPanel.addClass(aAddClass);
				$aList.velocity('slideDown', {
					easing: aEasing,
					duration: aDuration,
				});
			} else {
				$aPanel.removeClass(aAddClass);
				$aList.velocity('slideUp', {
					easing: aEasing,
					duration: aDuration,
				});
				gv_util.accordionAllClose($aPanel);
			}
		});
	};

	/**
	 * 下層アコーディオン一括で閉じる
	 */
	gv_util.accordionAllClose = ($aTargetAccordion)=> {
		const $areaPanel	= $aTargetAccordion.next('.head-menu-store-list')
		const $panelTitle	= $areaPanel.find('.store-area-list__area');
		const removeClass	= 'panel-open';

		if($areaPanel.length === 0) {
			return;
		}

		_.each($panelTitle, (aPanel) => {
			let $tempStoreList = $(aPanel).next('.store-area-list__shop');
			$(aPanel).removeClass(removeClass);
			$tempStoreList.velocity('slideUp', {
				easing: 'easeInOutQuart',
				duration: 300,
			});
		});
	};

	/**
	 * 現在日文字列（yyyymmdd）を取得
	 * @return {String} -現在日文字列
	 */
	gv_util.getTodayStr = ()=> {
		let today	= new Date();
		let yyyy	= today.getUTCFullYear();
		let mm		= today.getMonth() + 1;
		let dd		= today.getDate();

		return `${yyyy}${mm}${dd}`;
	};

	/**
	 * 日付文字列(yyyymmdd)から月、日の0埋め解除
	 * @param  {String} aDateStr	- 日付文字列
	 * @return {String}				- 変換済み文字列
	 */
	gv_util.convDateStrDelZeroPadding = (aDateStr)=> {
		let strYear		= aDateStr.replace(/^(\d{4}).*/, '$1');
		let strMonth	= aDateStr.replace(/^\d{4}(\d{2}).*/, '$1').replace(/^0/, '');
		let strDate		= aDateStr.replace(/.*(\d{2})$/, '$1').replace(/^0/, '');

		return `${strYear}${strMonth}${strDate}`;
	};


	/**
	 * 現在日付から時・分・秒を切り捨てた時間を取得
	 * @return {Number} - 現在日の時間数値
	 */
	gv_util.getTodayTimeNumber = () => {
		let today	= new Date();
		let yyyy	= today.getFullYear();
		let mm		= today.getMonth() + 1;
		let dd		= today.getDate();

		return new Date(`${yyyy}/${mm}/${dd}`).getTime();
	};

	/**
	 * 引数 日付文字列（yyyymmdd）から日付変換し、
	 * 時間数値へ変換し返却
	 * @param  {String} aDate	- 対象日付文字列
	 * @return {Number}			- 変換済み日付数値
	 */
	gv_util.getSetTimeNumber = (aDate)=> {
		let convDateStr = aDate.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1/$2/$3');
		return new Date(convDateStr).getTime();
	};

	/**
	 * リンク遷移タイプに適しtargetの値を返却
	 * @param  {String} aLinkType	- リンク遷移タイプ
	 * @return {String} result		- 結果文字列
	 */
	gv_util.getLinkTypeValue = (aLinkType) => {
		let device = gv_util.getMQDevice();
		let result;
		if(device === 'pc') {
			_.some(gv_cons.LINK_TYPE_MASTER_PC, (aAttr, aType) => {
				if(aLinkType === aType) {
					result = `${aAttr.attr}="${aAttr.value}"`;
					return true;
				}
			});
		} else if(device === 'sp') {
			_.some(gv_cons.LINK_TYPE_MASTER_SP, (aAttr, aType) => {
				if(aLinkType === aType) {
					result = `${aAttr.attr}="${aAttr.value}"`;
					return true;
				}
			});
		}
		return result;
	};

	/**
	 * サイト内リンク、外部リンクを判定し、Class名を返却
	 * サイト内リンク => inner-link、外部リンク => outer-link
	 * @param  {String} aAttribute	- 対象のリンク属性
	 * @return {String}				- 結果クラス名
	 */
	gv_util.getLinkClassName = (aLinkType) => {
		let device = gv_util.getMQDevice();
		let result;
		if(device === 'pc') {
			_.some(gv_cons.LINK_CLASS_MASTER_PC, (aClassName, aType) => {
				if(aLinkType === aType) {
					result = aClassName;
					return true;
				}
			})
		} else if(device === 'sp') {
			_.some(gv_cons.LINK_CLASS_MASTER_SP, (aClassName, aType) => {
				if(aLinkType === aType) {
					result = aClassName;
					return true;
				}
			})
		}
		return result;
	};

	/**
	 * USERAGENTを見てサイト内リンクの書き換え
	 * ※spの場合、頭に'/smp'を追加する
	 * @param  {String} aLinkUrl	- リンクURL
	 * @param  {String} aDevice		- デバイス判定文字列
	 * @return {String} result		- 変更済みURL
	 */
	gv_util.makeUrlSiteInner = (aLinkUrl, aDevice)=> {
		let validFlag = true;
		let extractDomain = gv_util.getExtractTranserDomain(location.hostname);
		let transerUrl;
		let result;
		let replaceUrl;

		if(!aLinkUrl) {
			return;
		}

		replaceUrl = aLinkUrl.replace(/^https?:\/\/www\.0101\.co\.jp(.*)/, '$1');

		if(aDevice === 'sp') {
			if(gv_cons.ADD_SMP_URL_REGEXP_TRANSER.test(replaceUrl)) {
				validFlag = true;
			} else {
				_.some(gv_cons.ADD_SMP_URL_REGEXP_LIST, (aRegExp) => {
					if(aRegExp.test(replaceUrl)) {
						validFlag = true;
						return true;
					} else {
						validFlag = false;
					}
				});
			}
		} else {
			validFlag = false;
		}

		_.some(gv_cons.TRANSER_ALL_ADD_DOMAIN, (aRegExp)=> {
			if(aRegExp.test(aLinkUrl)) {
				if(gv_util.checkReleaseDomain()) {
					replaceUrl = 'http://' + extractDomain + replaceUrl;
				}
				return true;
			}
		});


		if(!validFlag) {
			result = replaceUrl;
		} else {
			result	= `/smp${replaceUrl}`;
		}

		return result;

	};

	/**
	 * 現在のドメインから
	 * 翻訳用ドメイン文字列を除いた文字列を取得
	 * ※翻訳ドメインでは無い場合はそのまま返却
	 * @param  {String}	aHostName	- 現在のドメイン
	 * @return {String} result		- 抽出済み文字列
	 */
	gv_util.getExtractTranserDomain = (aHostName)=> {
		let result;
		_.some(gv_cons.TRANSER_ALL_ADD_DOMAIN, (aDomainRegExp)=> {
			if(aDomainRegExp.test(aHostName)) {
				result = aHostName.replace(aDomainRegExp, '$1');
				return true;
			}
		});
		if(!result) {
			result = aHostName;
		}
		return result;
	};

	/**
	 * APIオプションからネット通販へのURLを生成
	 * @param  {Object} aApiOption	- 通信設定
	 * @return {String} result		- 生成URL
	 */
	gv_util.makeUrlVoiLink = (aApiOption)=> {
		let resultParamAry = [];
		let resultParam;
		let result;
		_.each(aApiOption, (aParam, aKey)=> {
			let addParam;
			if(aKey !== 'jsonp') {
				addParam = `${aKey}=${aParam}`.replace(/\r?\n/g, '');
				resultParamAry.push(addParam);
			}
		});
		resultParam	= resultParamAry.join('&');
		result 		= `${gv_cons.BASE_WC_API_URL_SHOP}?${resultParam}`;
		return result;
	};

	/**
	 * リンクURLをから外部URL識別子を返却
	 * @param  {String} aLinkUrl	- リンクURL文字列
	 * @return {String}	aResultKey	- サイト識別子(voi|epos|from)
	 */
	gv_util.getSiteUrlType = (aLinkUrl)=> {
		let aResultKey;
		_.some(gv_cons.PARAM_KEY_COND, (aKey, aCond)=> {
			let tempCond = new RegExp(aCond);
			if(tempCond.test(aLinkUrl)) {
				aResultKey = aKey;
				return true;
			}
		});
		if(!aResultKey) {
			aResultKey = 'marui';
		}
		return aResultKey;
	};

	/**
	 * リンクURL文字列からエポスかネット通販の場合は
	 * trueを返却
	 * @param  {String} aLinkUrl	- リンクURL文字列
	 * @return {Boolean} result		- 結果
	 */
	gv_util.checkLinkGroupSite = (aLinkUrl)=> {
		let result = false;
		_.some(gv_cons.PARAM_KEY_COND, (aKey, aCond)=> {
			let linkRegExp = new RegExp(aCond);
			if(linkRegExp.test(aLinkUrl)) {
				result = true;
				return true;
			}
		});
		return result;
	};

	/**
	 * URLのクエリパラメータを連想配列化し返却
	 * @return  {Object} result	- 取得済みデータ
	 */
	gv_util.getUrlQueryParam = () => {
		let result	= {};
		let param	= location.search.substring(1).split('&');
		for(let i = 0; param[i]; i++) {
			if(param[i].indexOf('=') != -1) {
				let kv	= param[i].split('=');
				result[kv[0]] = gv_util.convSanitizingValue(kv[1]);
			} else {
				let kv	= param[i];
				result[kv[0]];
			}
		};
		return result;
	};

	/**
	 * 引数URLのクエリパラメータを連想配列に変換し返却
	 * @param  {String} aUrlStr	- 対象のURL文字列
	 * @return {Object}	result	- 変換済み連想配列
	 */
	gv_util.getArgUrlQueryParam = (aUrlStr)=> {
		let result	= {};
		if(!aUrlStr || aUrlStr.indexOf('?') === -1) {
			return result;
		}
		let param	= aUrlStr.replace(/.*\?(.*)/, '$1').split('&');
		for(let i = 0; param[i]; i++) {
			let kv	= param[i].split('=');
			if(kv[1]) {
				result[kv[0]] = gv_util.convSanitizingValue(kv[1]);
			} else {
				result[kv[0]];
			}
		};
		return result;
	};

	/**
	 * URLパラメータ取得時のサニタイジング
	 * @param  {String} aParamValue	- パラメータの値
	 * @return {String}				- 変換済み文字列
	 */
	gv_util.convSanitizingValue = (aParamValue)=> {
		return aParamValue.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	};

	/**
	 * URLから対象のパラメータ値を取得
	 * @param  {String} aParamKey	- 対象のパラメーターキー
	 * @return {String}	result		- 取得済みパラメータ値
	 */
	gv_util.getParamFromUrl = (aParamKey)=> {
		let convUrlParam = gv_util.getUrlQueryParam();
		let result;
		_.some(convUrlParam, (aValue, aKey)=> {
			if(aParamKey === aKey) {
				result = aValue;
				return true;
			}
		});
		return result;
	};

	/**
	 * 全角文字を半角へ変換
	 * @param  {String} aStr		- 対象文字列
	 * @return {String} resultStr	- 半角変換済み文字列
	 */
	gv_util.convZen2Han	= (aStr)=> {
		let resultStr = '';

		resultStr = aStr.replace(/[！-～]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
		});

		return resultStr;
	};

	/**
	 * URLにパラメータを付与
	 * @param  {String} path	- 追加元のURL文字列
	 * @param  {String} key		- 追加するパラメータのキーの名称
	 * @param  {String} value	- 追加するパラメータの値
	 * @param  {Boolean} save	- 上書きするかどうか
	 * @return {String} result	- パラメータ付与文字列
	 */
	gv_util.addUrlParam = (path, key, value, save)=> {
		let result = '';

		if (path && key && value) {
			let
				addParam		= key + '=' + value,
				paths			= path.split('/'),
				fullFileName	= paths.pop(),
				fileName		= fullFileName.replace(/^(.*?)[\?#].*/, '$1'),
				dirName			= path.replace(fullFileName, ''),
				hashMatches		= fullFileName.match(/#([^#]+)$/),
				paramMatches	= fullFileName.match(/\?([^\?]+)$/),
				hash			= '',
				param			= '',
				params			= [],
				fullPath		= '',
				hitParamIndex	= -1;

			if (hashMatches && hashMatches[1]) {
				hash = hashMatches[1];
			}

			if (paramMatches && paramMatches[1]) {
				param = paramMatches[1].replace(/#[^#]+$/g, '').replace('&', '&');
			}

			fullPath = dirName + fileName;

			if (param === '') {
				param = addParam;
			} else if (save) {
				params = param.split('&');

				for (var i = 0, len = params.length; i < len; i++) {
					if (params[i].match(new RegExp('^' + key + '='))) {
						hitParamIndex = i;
						break;
					}
				}
				if (hitParamIndex > -1) {
					params[hitParamIndex] = addParam;
					param = params.join('&');
				} else {
					param += '&' + addParam;
				}
			} else {
				param += '&' + addParam;
			}
			fullPath += '?' + param;
			if (hash !== '') {
				fullPath += '#' + hash;
			}
			result = fullPath;
		}
		result.replace(/\r?\n/g, '');
		return result;
	};


	/**
	 * TTS表示順ソート処理(昇順)
	 * @param  {Object} a - 対象オブジェクトA
	 * @param  {Object} b - 対象オブジェクトB
	 */
	gv_util.sortDispSeq = (a, b)=> {
		let dispSeqA = Number(a.sort);
		let dispSeqB = Number(b.sort);

		if(dispSeqA < dispSeqB ) return -1;
		if(dispSeqA > dispSeqB ) return 1;
		return 0;
	};


	/**
	 * 指定したSelector内にリンクタグを検索し、
	 * 要素全体をリンク設定
	 * ※リンクは１つまで
	 * @param  {jQuerySelector} $aElem - リンクタグが含まれる親要素
	 */
	gv_util.setWrapLink = ($aElem) => {

		const evListner = 'click';

		$aElem.on(evListner, (elem)=>{
			let $linkTag	= $(elem.currentTarget).find('a');
			let linkObj		= {
				url		: $linkTag.attr('href'),
				target	: $linkTag.attr('target'),
				popup	: $linkTag.attr('data-link'),
			};

			gv_util.setLinkType(linkObj);
			return false;

		});
	};

	/**
	 * ローテーションバナースワイプ時に
	 * クリックイベントが発火してしまう為
	 * mousedown/mouseupイベントを利用しリンク設定
	 * @param {jQuerySelector} $aRote	- ローテーションバナー全体の要素
	 */
	gv_util.setRoteLink = (aRote)=> {
		let $rote = $('.slick-list');
		let $rote_item = $('.slick-list').find('li');
		let activeBnrClass = 'slick-active';

		_.each($rote_item, (aList) => {
			let linkElem	= $(aList).find('a');

			linkElem.off('click mousedown mouseup');
			linkElem.on({
				'click'		: ()=> { return false;},
				'mousedown'	: (ev)=> {
					let bnrIdx		= $(aList).data('slick-index');
					let isCenterBnr = new RegExp(activeBnrClass).test($(aList).attr('class'));

					let linkObj		= {
						url		: linkElem.attr('href'),
						target	: linkElem.attr('target'),
						popup	: linkElem.attr('data-link'),
					}

					if(gv_util.getMQDevice() === 'sp') {
						if(typeof linkObj.popup !== 'undefined') {
							linkObj.target	= '_blank';
							linkObj.popup	= 'undefined';
						}
					}

					if(ev.which !== 1){ return false}
					let linkPos	= ev.clientX;
					$(ev.currentTarget).on('mouseup', (addEv)=> {
						let addLinkPos = addEv.clientX;
						if(linkPos === addLinkPos) {
							if(isCenterBnr) {
								gv_util.setLinkType(linkObj);
							} else {
								$(aRote).slick('slickGoTo', bnrIdx);
							}
							return false;
						}
					})
				}
			})
		});
	};

	/**
	 * [ネット通販API連携]
	 * URLが正しいか判定
	 * @param  {String} aEcUrl	- ネット通販URL
	 * @return {Boolean}		- 対象URLの場合はTrue
	 */
	gv_util.checkEcUrl = (aEcUrl)=> {
		const voiReg	= /^https?:\/\/search-voi\.0101\.co\.jp\/(voi\/|voi\/sp\/|)(shop|freeword|item|webshop|brand)\/.*/;
		if(voiReg.test(aEcUrl)) {
			return true;
		} else {
			return false;
		}
	};

	/**
	 * [ネット通販API連携]
	 * ショップ名称を取得
	 * @param  {String} aEcUrl			- ネット通販URL
	 * @return {String} resultShopName	- 対象のショップ名
	 */
	gv_util.getEcUrlShopName = (aEcUrl)=> {
		return aEcUrl.replace(/.*voi\.0101\.co\.jp(\/voi\/|\/voi\/sp\/|\/)shop\/(.*?)\/.*/, '$2');
	};

	/**
	 * TTS入力API用URLからAPIタイプを取得
	 * @param  {String} aUrl   - TTS入力ネット通販URL
	 * @return {Object} result - APIオプション用オブジェクト
	 */
	gv_util.getApiTypeFromUrl = (aUrl)=> {
		const TypeIdxNum       = 3;
		const TypeDetailIdxNum = 4;
		const TypeItemIdxNum   = 5;
		const ApiTypeList = [
			'shop',
			'webshop',
			'freeword',
			'item',
			'brand',
		];
		let result = {};
		let convUrl, urlAry;

		if(!aUrl) return;
		convUrl = aUrl.replace(/(\/voi\/|\/voi\/sp\/)/, '/');
		urlAry  = convUrl.split('/');

		if(_.contains(ApiTypeList, urlAry[TypeIdxNum])) {
			switch(urlAry[TypeIdxNum]) {
				case 'shop' :
					result = {
						factor: 'shop',
						shop  : urlAry[TypeDetailIdxNum],
					};
				break;
				case 'webshop' :
					result = {
						factor: 'wno',
						wno  : urlAry[TypeDetailIdxNum],
					};
				break;
				case 'brand' :
					result = {
						factor: 'brand',
						bcd  : urlAry[TypeDetailIdxNum],
					};
				break;
				case 'freeword' :
					result = {
						factor: 'freeword',
						q  : gv_util.getArgUrlQueryParam(aUrl).q,
					};
				break;
				case 'item' :
					result = {
						factor: urlAry[TypeDetailIdxNum]
					}
					result[urlAry[TypeDetailIdxNum]] = urlAry[TypeItemIdxNum];
				break;
			}
		}
		result['per'] = 30;
		if(gv_util.getArgUrlQueryParam(aUrl).sortby) {
			result['sortby'] = gv_util.getArgUrlQueryParam(aUrl).sortby;
		}
		return result;
	};


	/**
	 * リンク区分毎の設定
	 * @param  {Object} aLinkObj	- リンク情報
	 * - aLinkObj.url		= リンクURL,
	 * - aLinkObj.target	= target属性,
	 * - aLinkObj.popup		= data-link属性（ポップアップ時に利用）
	 */
	gv_util.setLinkType = (aLinkObj)=> {
		if(typeof aLinkObj.target !== 'undefined') {
			if(aLinkObj.target === '_self') {
				location.href = aLinkObj.url;
			} else if(aLinkObj.target === '_blank') {
				window.open(aLinkObj.url, '_blank');
			}
		} else {
			if(aLinkObj.popup === 'popup-s'){
				window.open(aLinkObj.url, '', 'width=550,height=450,scrollbars=1');
			} else if(aLinkObj.popup === 'popup-l') {
				window.open(aLinkObj.url, '', 'width=760,height=640,scrollbars=1');
			} else {
				location.href = aLinkObj.url;
			}
		}
	};


	/**
	 * アクセシビリティ対応
	 * 対象のエレメント選択時キーボード”Enter”で
	 * トリガーイベント起動
	 * @param {jQuerySelector} $aBtn		- 発火対象エレメント
	 * @param {String} aTrigger				- トリガーイベント
	 * @param {jQuerySelector} $aTriggerElem	- トリガーエレメント
	 */
	gv_util.keyPressTriggerEv	= ($aBtn, aTrigger, $aTriggerElem = null)=> {
		$aBtn.on('keypress', (elem)=> {
			if(gv_util.isEnterPress(elem)) {
				if(!$aTriggerElem) {
					$(elem.currentTarget).trigger(aTrigger);
				} else {
					$aTriggerElem.trigger(aTrigger);
				}
			}
		})
	};

	/**
	 * キーボードEnterキーのみが押されたか判定
	 * @param  {element} aElem	- 対象のエレメント
	 * @return {Boolean}		- エンターキーの場合はtrue
	 */
	gv_util.isEnterPress = (aElem)=> {
		let keyCode			= aElem.keyCode;
		let isKeyShift		= aElem.shiftKey;
		let isKeyCtrl		= aElem.ctrlKey;
		let isKeyAlt		= aElem.altKey;
		let result;

		if(keyCode !== 13 || ( keyCode === 13 && (isKeyShift || isKeyCtrl || aElem.altKey) )) {
			result = false;
		} else {
			result = true;
		}

		return result;
	};

	/**
	 * URLから店舗番号を取得
	 * @return {String}		- 店舗番号
	 */
	gv_util.getStoreCode	= ()=> {
		let pathAry				= location.pathname.split('/');
		let stcdRegExp			= /\d{3}/;
		let shopMailPrimaryDir	= 'shopmail';
		let isStorePage			= stcdRegExp.test(pathAry[1]);
		let isShopMailPage		= pathAry[1] === shopMailPrimaryDir;
		let result;

		if(isStorePage) {
			result = pathAry[1];
		}

		if(isShopMailPage) {
			result = pathAry[2].replace(/^00(\d{3}).*/, '$1');
		}

		if(result) {
			return result;
		}
	};

})();
